<div class="content-wrapper container-xxl p-0">
    <div class="content-body">

        <div class="card mb-0">
            <div class="card-body">

                <div class="row">
                    <div class="col-md-12 text-center mt-20" *ngIf="noDataFound">
                        <div class="text-black fw-500 ">
                            <div class="fs-12"> No orders found </div>
                        </div>
                    </div>
                </div>
                <loader *ngIf="showLoader"></loader>
                <div class="row mt-20" *ngIf="!noDataFound">
                    <div class="col-md-12 card-body p-20" *ngFor="let singleOrder of orderList" style="border-bottom:1px dashed ">
                        <div class="" (click)="goToOrderDetails(singleOrder.id)" style="cursor: pointer; box-shadow: 0 0 0 0 !important;">
                            <div class="row">
                                <div class="col-md-12 col-12 mb-10">
                                    <span class="card-title fs-14 fw-600 text-black">Order Id : #{{singleOrder.displayOrderId}}
                                    </span>
                                    <span  *ngIf="orderType != 'xplorer'" class="fs-11 fw-600" [ngClass]="(singleOrder.orderStatus == 'EXPIRED' || singleOrder.orderStatus ==  'CANCELLED' || singleOrder.orderStatus ==  'REJECTED') ?  'badge badge-danger' : (singleOrder.orderStatus ==  'IN_PROCESS') ? 'badge badge-warning' : 'badge badge-success'">
                                        {{singleOrder.orderStatus }}</span>
                                </div>
                            </div>
                            <div class="row" *ngIf="orderType == 'xplorer'">
                                <div class="col-md-12 col-12">
                                    <span class="card-text fs-11 text-black fw-600">Order Type : Xplorer Card Kit</span>
                                </div>
                            </div>
                            <div class="row" *ngIf="orderType == 'xplorer'">
                                <div class="col-md-12 col-12">
                                    <span class="card-text fs-11 text-black fw-600">Order Status : </span>
                                    <span class="fs-11 text-black"> {{ singleOrder.status}}</span>
                                </div>
                            </div>
                            <div class="row" *ngIf="orderType == 'xplorer'">
                                <div class="col-md-12 col-12">
                                    <span class="card-text fs-11 text-black fw-600">Kit Fee : </span>
                                    <span class="fs-11 text-black"> {{ singleOrder.kitFee}}</span>
                                </div>
                            </div>
                            <div class="row" *ngIf="orderType == 'xplorer'">
                                <div class="col-md-12 col-12">
                                    <span class="card-text fs-11 text-black fw-600">Total Amount : </span>
                                    <span class="fs-11 text-black"> {{ singleOrder.totalAmount}}</span>
                                </div>
                            </div>
                            <div class="row" *ngIf="orderType != 'xplorer'">
                                <div class="col-md-12 col-12">
                                    <span class="card-text fs-11 text-black fw-600">Created On : </span>
                                    <span class="fs-11 text-black">{{ singleOrder.createdAt | date:'dd/MM/yyyy' }}</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>